export type IGetUuidValueInUrl = (url: string) => string | null;

export function getUuidValueInUrl(url: string): string | null {
  const uuid = window.DexeroCoreApp.getUrlParamValue('uuid', url);
  if (uuid) {
    return uuid;
  }
  const parsedUrl = window.DexeroCoreApp.paraseURL(url);
  if (parsedUrl.urlBase) {
    const { urlBase } = parsedUrl;
    if (urlBase.match(/\/(.*?)\/(.*?)\/(.*?)\/t\/(.*?)\/a\/(.*?)\/(.+?(?=$|\?|\/))/) !== null) {
      return (urlBase as any).match(
        /\/(.*?)\/(.*?)\/(.*?)\/t\/(.*?)\/a\/(.*?)\/(.+?(?=$|\?|\/))/
      )[6];
    }
    if (urlBase.match(/\/(.*?)\/(.*?)\/(.*?)\/a\/(.*?)\/(.+?(?=$|\?|\/))/) !== null) {
      return (urlBase as any).match(/\/(.*?)\/(.*?)\/(.*?)\/a\/(.*?)\/(.+?(?=$|\?|\/))/)[5];
    }
  }
  return null;
}
